// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-icon {
  display: flex;
  padding: 0.375rem 0.75rem;
  background-color: white;
  height: 2.25rem;
  margin-top: 0.95rem;
  border-radius: 7px 0px 0px 7px;
}

.input-icon img {
  width: 1.3rem;
}

.input-nlp.custom-input {
  padding-left: 0;
  border-radius: 0px 7px 7px 0px !important;
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/Shared/IconInput/IconInput.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,eAAA;EACA,yCAAA;EACA,uBAAA;AACJ","sourcesContent":[".input-icon {\n    display: flex;\n    padding: 0.375rem 0.75rem;\n    background-color: white;\n    height: 2.25rem;\n    margin-top: 0.95rem;\n    border-radius: 7px 0px 0px 7px;\n}\n\n.input-icon img{\n    width: 1.3rem;\n}\n\n.input-nlp.custom-input {\n    padding-left: 0;\n    border-radius: 0px 7px 7px 0px !important;\n    background-color: white;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
